<template>
  <div>
    <ui-button
      class="integration-button"
      color="primary"
      :disabled="isDisabled"
      @click="pagesNotFound ? goToFacebookAccount() : toggleDialog()"
    >
      <span>{{ buttonLabel }}</span>
      <ReviewProcessingIcon v-if="isDisabled" />
    </ui-button>
    <FacebookToggleDialog v-if="showDialog" @close="showDialog = false" />
  </div>
</template>

<script>
const PROGRESS_ENUM = {
  OTHER: 0,
  PAGES_NOT_FOUND: 1,
  MATCHING: 2
};
import ReviewProcessingIcon from "@/components/ui/Icons/ReviewProcessingIcon.vue";
export default {
  name: "ToggleFacebookIntegrationButton",
  components: {
    ReviewProcessingIcon,
    FacebookToggleDialog: () =>
      import("@/components/BusinessAddresses/FacebookToggleDialog.vue")
  },
  props: {
    progress: {
      type: Number
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    pagesNotFound() {
      return this.progress === PROGRESS_ENUM.PAGES_NOT_FOUND;
    },
    isDisabled() {
      return this.progress === PROGRESS_ENUM.MATCHING;
    },
    buttonLabel() {
      if (this.progress === undefined)
        return this.$t(`message.mapIntegrations.enable`);
      return this.pagesNotFound
        ? this.$t("message.facebook.completeConfiguration")
        : this.$t("message.facebook.configurationInProgress");
    }
  },
  methods: {
    toggleDialog() {
      this.showDialog = true;
    },
    goToFacebookAccount() {
      this.$router.push({ name: "profile-facebook-accounts" });
    }
  }
};
</script>
<style lang="scss" scoped>
.integration-button {
  max-width: 150px;
  ::v-deep .v-btn__content {
    display: flex;
    align-items: center;
    gap: $spacing;
    width: 100%;

    svg {
      flex-shrink: 0;
    }

    span {
      white-space: break-spaces;
      text-align: left;
    }
  }
}
</style>
